import { memo } from 'react'
import { useTranslate } from '../../../../../hooks/language/use-translate'
import type { TypeGameBoxLocal } from '../../../../../services/games/games-boxes-rooms/types'

interface Props {
  onSelect: (typeGameBoxLocal: TypeGameBoxLocal) => void
  onClose?: () => void
}

export const ModalLocal = memo(({ onSelect, onClose }: Props) => {
  const options: TypeGameBoxLocal[] = ['country', 'global', 'room']

  const { translate } = useTranslate()

  return (
    <div className="fixed inset-0 flex flex-col justify-end bg-black/40 z-50">
      <div className="bg-white rounded-t-3xl px-4 pt-4 h-1/2 w-full flex flex-col">
        <div className="flex flex-col divide-y divide-gray-200">
          {options.map((option) => (
            <button
              key={option}
              onClick={() => {
                onSelect?.(option)
                onClose?.()
              }}
              className="py-4 text-center text-gray-700 text-base hover:bg-gray-100 transition"
            >
              {translate(`modal-local-${option}`)}
            </button>
          ))}
        </div>

        <div className="flex flex-1 items-end justify-center pb-10">
          <button
            onClick={onClose}
            className="text-center text-red-500 font-medium hover:bg-gray-100 rounded-lg transition"
          >
            {translate('modal-game-box-cancel-button')}
          </button>
        </div>
      </div>
    </div>
  )
})

ModalLocal.displayName = 'ModalLocal'
